import { combineEpics } from 'redux-observable';

import {
  AboutusEpic,
  CookiesEpic,
  getAboutusEpic,
  getCookiesEpic,
  getHomedataEpic,
  getPrivacyPolicyEpic,
  getSubsriptionpolicyEpic,
  getTermandCondEpic,
  HomedataEpic,
  PrivacyPolicyEpic,
  SubscriptionpolicyEpic,
  TermandCondEpic,
} from './ContentManageEpic';
import {
  AcceptRejectDomainEpic,
  BloomEpic,
  BloomSubEpic,
  DashboardEpic,
  DeleteUserEpic,
  DreamEpic,
  EditInfluencerUserEpic,
  EducationEpic,
  FreeSubEpic,
  FreeUserEpic,
  GetDomainDetailsEpic,
  GetDomainInfoListEpic,
  GetEthnicityUserEpic,
  GetFriendsInvitationsEpic,
  GetMessageDetailsEpic,
  GetMessageListEpic,
  GetQueryDetailsEpic,
  GetQueryUserEpic,
  GetSubUserEpic,
  GetUsersFeedbackEpic,
  HobbiesEpic,
  InterstedeEpic,
  MySelfEpic,
  OpenCloseSupportEpic,
  PermiumEpic,
  PermiumSubEpic,
  RelationEpic,
  ReligionEpic,
  ResumeSuspendUserEpic,
  SendAdminMessageResponseEpic,
  SendAdminQueryResponseEpic,
  SubscriptionEpic,
} from './DashboardEpic';
import { AddDreamEpic, EditDreamEpic } from './DreamManagementEpic';
import { AddEducationEpic, EditEducationEpic } from './EducationManagementEpic';
import { AddEthnicityEpic, EditEthnicityEpic } from './EthnicityManagementEpic';
import { AddHobbiesEpic, EditHobbiesEpic } from './HobbiesManagementEpic';
import { AddInterstedEpic, EditInterstedEpic } from './InterstedManagementEpic';
import { AddMySelfEpic, EditMySelfEpic } from './MySelfManagementEpic';
import { ForgotPassEpic, GetAdminProfileEpic, UpdateAdminProfileEpic } from './ProfileEpic';
import { AddRelationshipEpic, EditRelationshipEpic } from './RelationManagementEpic';
import { AddReligionEpic, EditReligionEpic } from './ReligionManagementEpic';
import { SignInEpic, TermsAndConditionsEpic } from './SignInEpic';
import { AddFreePremiumEpic, AddUserEpic, EditUserEpic, SendAdminMessageEpic } from './UserManagementEpic';

const rootEpic = combineEpics(
  TermsAndConditionsEpic,
  EditReligionEpic,
  AddReligionEpic,
  ReligionEpic,
  EditEducationEpic,
  AddEducationEpic,
  EducationEpic,
  EditMySelfEpic,
  AddMySelfEpic,
  MySelfEpic,
  HobbiesEpic,
  EditHobbiesEpic,
  AddHobbiesEpic,
  InterstedeEpic,
  EditInterstedEpic,
  AddInterstedEpic,
  EditRelationshipEpic,
  AddRelationshipEpic,
  RelationEpic,
  EditDreamEpic,
  AddDreamEpic,
  SignInEpic,
  DashboardEpic,
  DreamEpic,
  SubscriptionEpic,
  DeleteUserEpic,
  AcceptRejectDomainEpic,
  GetDomainInfoListEpic,
  EditUserEpic,
  AddUserEpic,
  SendAdminMessageEpic,
  AddFreePremiumEpic,
  PrivacyPolicyEpic,
  AboutusEpic,
  TermandCondEpic,
  CookiesEpic,
  getTermandCondEpic,
  getAboutusEpic,
  getPrivacyPolicyEpic,
  getCookiesEpic,
  UpdateAdminProfileEpic,
  GetAdminProfileEpic,
  ForgotPassEpic,
  getSubsriptionpolicyEpic,
  SubscriptionpolicyEpic,
  HomedataEpic,
  getHomedataEpic,
  GetSubUserEpic,
  GetQueryUserEpic,
  GetEthnicityUserEpic,
  AddEthnicityEpic,
  EditEthnicityEpic,
  PermiumEpic,
  PermiumSubEpic,
  BloomEpic,
  BloomSubEpic,
  FreeSubEpic,
  FreeUserEpic,
  GetMessageListEpic,
  ResumeSuspendUserEpic,
  GetQueryDetailsEpic,
  SendAdminQueryResponseEpic,
  OpenCloseSupportEpic,
  GetDomainDetailsEpic,
  EditInfluencerUserEpic,
  GetMessageDetailsEpic,
  SendAdminMessageResponseEpic,
  GetUsersFeedbackEpic,
  GetFriendsInvitationsEpic,
);
export default rootEpic;
